/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import gql from "graphql-tag.macro";

const gqlUserContextQuery = gql`
  query getUserContext($v3ProjectId:ID!,$v3UserId:ID!) {
    userContext(v3ProjectId: $v3ProjectId, v3UserId: $v3UserId) {
      userId
      position
      level
      featureFavourites {
        name
        projectId
        created
      }
    }
  }

`;

const gqlUserContextAboutYou = gql`
  mutation mutationUserContextAboutYou($v3UserId:ID!,$position:String,$level:String) {
    updateUserContextAboutYou(v3UserId:$v3UserId, position:$position, level:$level){
      userId
      position
      level
      featureFavourites{
        name
        projectId
      }
    }
  }
`;

const gqlUpdateInstanceContext = gql`
  mutation UpdateInstanceContext($id:ID!,$input:InstancContextInput!) {
    updateInstanceContext(id:$id,input:$input){
      context{
        name
        website
        industry
        description
      }
    }
  }
`;

const gqlLoadInstance = gql`
  query {
    currentInstance {
      ... on Instance {
        _id
        name
        context{
          name
          website
          industry
          description
        }
      }
    }
  }
`;

export const loadUserContext = async ({ client }) => {
  const {
    data: { userContext },
  } = await client.query({
    query: gqlUserContextQuery,
    variables: { v3ProjectId: window.app.Duchess.currentProject._id, v3UserId: window.app.Duchess.currentUser._id },
    fetchPolicy: "no-cache"
  });

  return userContext;
};

export const updateUserContextAboutYou = async ({ formValues }, { client }) => {
  const { position, level } = formValues;
  const {
    data: { updateUserContextAboutYou },
  } = await client.mutate({
    mutation: gqlUserContextAboutYou,
    variables: { v3UserId: window.app.Duchess.currentUser._id, position, level },
  });

  return updateUserContextAboutYou;
};

export const updateInstanceAboutCompany = async ({ id, context }, { client }) => {
  const {
    data: { updateInstanceContext },
  } = await client.mutate({
    mutation: gqlUpdateInstanceContext,
    variables: { id, input: context },
  });

  return updateInstanceContext?.context || {
    name: null,
    website: null,
    induestry: null,
    description: null
  };
};

export const loadInstanceContext = async ({ client }) => {
  const {
    data: { currentInstance },
  } = await client.query({
    query: gqlLoadInstance,
    fetchPolicy: "no-cache"
  });

  return currentInstance?.context || {
    name: null,
    website: null,
    industry: null,
    description: null,
  };
};
